import moment from 'moment'
require('moment/locale/it')

export default ({ Vue }) => {
  // Vue.filter('currency', a => (a / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
  Vue.filter('currency', function (value) {
    if (typeof value !== 'number') return value
    return new Intl.NumberFormat('it', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
    }).format(value)
  })
  Vue.filter('short', function (value, digits = 0) {
    const si = [
      { value: 1, symbol: '' },
      { value: 1E3, symbol: 'k' },
      { value: 1E6, symbol: 'M' },
      { value: 1E9, symbol: 'G' },
      { value: 1E12, symbol: 'T' },
      { value: 1E15, symbol: 'P' },
      { value: 1E18, symbol: 'E' }
    ]
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
    let i
    for (i = si.length - 1; i > 0; i--) {
      if (value >= si[i].value) {
        break
      }
    }
    return (value / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
  })

  Vue.filter('human', (a, without = false) => moment(String(a)).fromNow(without))
  // Vue.filter('Y-m-d', a => moment(String(a)).format('YYYY-MM-DD'))
  Vue.filter('L', a => moment(String(a)).format('L')) // 26/10/2019
  Vue.filter('LT', a => moment(String(a)).format('LT')) // 18:01
  Vue.filter('LL', a => moment(String(a)).format('LL')) // 26 ottobre 2019
  Vue.filter('ll', a => moment(String(a)).format('ll')) // 26 ott 2019
  Vue.filter('L.', a => moment(String(a)).format('DD.MM.YYYY'))
  Vue.filter('MY', a => moment(String(a)).format('MMM YYYY'))
  Vue.filter('MMY', a => moment(String(a)).format('MMMM YYYY'))
  Vue.filter('My', a => moment(String(a)).format('MMM [\']YY'))
  Vue.filter('years', a => moment().diff(moment(String(a)), 'years'))
  Vue.filter('months', a => moment().diff(moment(String(a)), 'months'))
  Vue.filter('yearsFrom', (a, b) => moment(String(b)).diff(moment(String(a)), 'years'))
  Vue.filter('monthsFrom', (a, b) => moment(String(b)).diff(moment(String(a)), 'months'))

  Vue.filter('letters', (a = '') => a.split(' ').map(([first = '']) => first.toUpperCase()).join(''))
  Vue.filter('no-caps', (a = '') => a.split(' ').map(([first = '', ...rest]) => first.toUpperCase() + rest.map(w => w.toLowerCase()).join('')).join(' '))
}
